// Copyright (c) 2022 by Move Closer

import { AsyncComponent } from 'vue'

import { PossibleAddon } from '../../../../modules/Hero/Hero.contracts'
import { PossibleSnippets } from '../../../../modules/Navbar/Navbar.config'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export type DirectionsType = {[key: string]: number}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const MEGA_MENU_COMPONENT_KEY = 'MegaMenuComponent'

export const MEGA_MENU_DEFAULT_CONFIG: MegaMenuConfig = {
  hasColumnAdditionalHeaderOnBottom: false,
  headerLinkSize: 'x-small',
  hasAdditionalContent: false,
  hasPagination: false,
  hasAdditionalContainer: false,
  navCategoryItemAsHeading: true
}

export interface MegaMenuConfig {
  hasColumnAdditionalHeaderOnBottom: boolean
  headerLinkSize: string
  hasAdditionalContent: boolean
  hasPagination: boolean
  hasAdditionalContainer: boolean
  navCategoryItemAsHeading: boolean
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export enum DIRECTIONS {
  DECREMENT = 'decrement',
  INCREMENT = 'increment'
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const DISABLED_CLASS = 'disabled'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const PAGINATION_BUTTON_SELECTOR = '.MegaMenuPagination button'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const TRANSLATE_ANIMATION_DURATION = 300

/**
 * Maps `AdoonType` to `VueConstructor`
 *
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const megaMenuModuleUiRegistry: Record<PossibleAddon, AsyncComponent> = {
  [PossibleSnippets.Image]: () => import(/* webpackChunkName: "shared/ImageAddon" */ './addons/ImageAddon.vue'),
  [PossibleSnippets.CTABox]: () => import(/* webpackChunkName: "shared/CTABoxAddon" */ './addons/CTABoxAddon.vue')
}
